module.exports = __webpack_public_path__ + "static/assets/780da7015fb50f3e8b91b27b61fd95c7.gif";